const INTEREST_ZIP_KEY = 'interestZip';

export function getInterestZip() {
  return window.sessionStorage.getItem(INTEREST_ZIP_KEY) || null;
}

export function setInterestZip(zip) {
  if (zip) {
    window.sessionStorage.setItem(INTEREST_ZIP_KEY, zip);
  }
}

export default {getInterestZip, setInterestZip};
